var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#2AAC9C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_119259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7 26.03L12 20.33L13.43 18.9L17.71 23.18L26.88 14L28.31 15.43L17.7 26.03Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_119259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3,
    height: 12.03,
    fill: "white",
    transform: "translate(12 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckM);
export default __webpack_public_path__ + "static/media/Ic_check_M.3e6ff7625a80d92a875a159feb382466.svg";
export { ForwardRef as ReactComponent };